import { createSlice } from "@reduxjs/toolkit";
import {
  ContributionData,
  ContributionInitialStatus,
} from "../../../../../types/webCms/aboutUs/contribution";
import {
  getAllContributionAsync,
  updateContributionAsync,
} from "./contributionApi";

const initialState: ContributionInitialStatus<ContributionData> = {
  loading: false,
  manageLoading: false,
  ContributionDataList: [],
  countContributionData: 0,
};

const contributionSlice = createSlice({
  name: "admin-contribution",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // get all
    builder
      .addCase(getAllContributionAsync.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getAllContributionAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.ContributionDataList = action.payload.data;
        state.countContributionData = action.payload.length;
      })
      .addCase(getAllContributionAsync.rejected, (state) => {
        state.loading = false;
        state.ContributionDataList = [];
        state.countContributionData = 0;
      });

    // update
    builder
      .addCase(updateContributionAsync.pending, (state) => {
        state.manageLoading = true;
      })
      .addCase(updateContributionAsync.fulfilled, (state) => {
        state.manageLoading = false;
      })
      .addCase(updateContributionAsync.rejected, (state) => {
        state.manageLoading = false;
      });
  },
});

export default contributionSlice;
